import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sub_page_con wrap_1120" }
const _hoisted_2 = { class: "bread_crumbs" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between","align-items":"baseline","margin-bottom":"10px"} }
const _hoisted_4 = {
  key: 0,
  class: "btn_wrap _default _board_type",
  style: {"justify-content":"flex-end"}
}
const _hoisted_5 = { class: "search_wrap" }
const _hoisted_6 = { class: "list_table con_board sub_page_con_view faqList" }
const _hoisted_7 = { class: "tr_div con_tit" }
const _hoisted_8 = { class: "tb_subject" }
const _hoisted_9 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "icon_wrap"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: "img/home_icon.png",
              alt: "홈"
            }, null, -1)
          ]))]),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createStaticVNode("<span class=\"icon_wrap\" data-v-16435c86><img src=\"img/part_icon.png\" alt=\"소개\" data-v-16435c86></span><span class=\"faq_list_title\" data-v-16435c86>소개</span><span class=\"icon_wrap\" data-v-16435c86><img src=\"img/part_icon.png\" alt=\"자주묻는 질문(FAQ)\" data-v-16435c86></span><span class=\"faq_list_title\" data-v-16435c86>자주묻는 질문(FAQ)</span>", 4))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sub_con_tit" }, "FAQ", -1)),
        ($setup.state.hasAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                class: "common_btn w_130",
                to: { name: 'FaqWrite' }
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("글쓰기", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.searchText) = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)), ["enter"])),
          placeholder: "검색어를 입력하세요."
        }, null, 544), [
          [_vModelText, $setup.state.searchText]
        ]),
        _createElementVNode("button", {
          class: "search_btn icon_wrap",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: "img/search_btn.png",
            alt: ""
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", null, [
          ($setup.state.list.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "tbody_li",
                  key: item.idx
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("div", { class: "tb_no" }, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (index + 1)), 513), [
                      [_vShow, !$setup.state.isMobile]
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: { name: 'FaqView', params: { id: item.idx } },
                        class: "elips_1 block"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ])
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("li", _hoisted_9, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "tr_div" }, [
                  _createElementVNode("div", {
                    class: "tb_subject",
                    style: {"text-align":"center","width":"100%"}
                  }, "등록된 게시물이 없습니다.")
                ], -1)
              ]))]))
        ])
      ]),
      ($setup.state.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 0,
            currentPage: $setup.state.page,
            totalLength: $setup.state.totalLength,
            perPage: $setup.state.size,
            onOnPaging: $setup.handlePageChange
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true)
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}